import React, {useRef , useEffect} from 'react'
// import Webcam from 'react-webcam';
import styles from './style.module.css';

export default function WebcamComponent() {

        const webcamRef = useRef(null);
      
        useEffect(() => {
          // Access the webcam when the component mounts
          navigator.mediaDevices.getUserMedia({ video: true })
            .then((stream) => {
              webcamRef.current.srcObject = stream;
            })
            .catch((error) => {
              console.log('Error accessing webcam:', error);
            });
      
          return () => {
            // Cleanup: Stop accessing the webcam when the component unmounts
            if (webcamRef.current && webcamRef.current.srcObject) {
              webcamRef.current.srcObject.getTracks().forEach((track) => {
                track.stop();
              });
            }
          };
        }, []);
      
        return <div className={`${styles.container}`}>
            {/* <Webcam audio={false} ref={webcamRef} /> */}
            </div>;
      }


